<template>
	<div>
		<div class="container">
			<div class="row justify-content-center">
				<div class="col-8">
					<div class="card mt-5">
						<div class="card-header">Register</div>
						<div class="card-body">
							<div class="form-group row">
								<label for="username" class="col-md-4 col-form-label text-md-right">Username</label>
								<div class="col-md-6">
									<input type="text" id="username" class="form-control" name="username" required autofocus>
								</div>
							</div>
							<div class="form-group row">
								<label for="email_address" class="col-md-4 col-form-label text-md-right">E-Mail Address</label>
								<div class="col-md-6">
									<input type="email" id="email_address" class="form-control" name="email-address" required autofocus>
								</div>
							</div>


							<div class="form-group row">
								<label for="confirm" class="col-md-4 col-form-label text-md-right">Password</label>
								<div class="col-md-6">
									<input type="password" id="password" class="form-control" name="password" required>
								</div>
							</div>
							<div class="form-group row">
								<label for="confirm_password" class="col-md-4 col-form-label text-md-right">Confirm Password</label>
								<div class="col-md-6">
									<input type="password" id="confirm_password" class="form-control" name="confirm_password" required>
								</div>
							</div>

							<div class="col-md-6 offset-md-4">
								<button class="btn btn-primary">
									Register
								</button>
								<a href="#" class="btn btn-link">
									Forgot Your Password?
								</a>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	export default {

	}
</script>

<style>

</style>